import React from 'react'
import Select, { components } from 'react-select'
import { SocialAccountData } from '../../types/influencer/influencerTypes';
import dummyProfilePic from "../../assets/images/avatars/user-dummy-img.jpg"

const IGAccountSelector: React.FC<{socialAccount: SocialAccountData | null, socialAccounts: SocialAccountData[], onChange: (account: SocialAccountData | null) => void}> = ({ socialAccount, socialAccounts, onChange }) => {

    const changeSelectedSocialAccount = (accountUuid: string) => {
        const selectedAccount = socialAccounts?.find(a => a.social_account.uuid === accountUuid) || null;
        onChange(selectedAccount);
    }

    const options = (socialAccounts ?? [])
        .map(a => ({
            label: `@${a.social_account.handle}`,
            value: a.social_account.uuid,
            profile_picture_url: a.social_account.profile_picture_url
        }))
        .sort((a, b) => a.label.localeCompare(b.label))
        .sort((a) => (a.value === socialAccount?.social_account.uuid ? -1 : 1));



    const SingleValue = (props: any) => {
        return (
            <components.SingleValue {...props}>
                <img src={props.data.profile_picture_url ?? dummyProfilePic} alt={props.data.label} style={{ width: 20, height: 20, borderRadius: '50%', marginRight: 8 }} />
                {props.data.label}
            </components.SingleValue>
        );
    };

    const Option = (props: any) => {
        return (
            <components.Option {...props}>
                <img src={props.data.profile_picture_url ?? dummyProfilePic} alt={props.data.label} style={{ width: 20, height: 20, borderRadius: '50%', marginRight: 8 }} />
                {props.data.label}
            </components.Option>
        );
    };


    return (
        <Select
            className="social-account-select"
            classNamePrefix="rs"
            options={options}
            isSearchable={!(options.length <= 1)}
            menuIsOpen={options.length <= 1 ? false : undefined}
            onMenuOpen={options.length <= 1 ? () => { } : undefined}
            value={
                socialAccount
                    ? {
                        label: `@${socialAccount.social_account.handle}`,
                        value: socialAccount.social_account.uuid,
                        profile_picture_url: socialAccount.social_account.profile_picture_url

                    }
                    : null
            }
            onChange={(opt) => opt && changeSelectedSocialAccount(opt.value)}
            components={{ Option, SingleValue }}
        />
    )
}

export default IGAccountSelector
